module.exports = __webpack_public_path__ + "static/media/icon_inspections_lightblue.a291836a.svg";